import styles from "@/components/pages/home/components/searchbar/styles/filters-buttons.module.scss";
import React from "react";
import CreateCustomVoiceFilterButton from "@/components/pages/home/components/searchbar/components/create-custom-voice-filter-button";
import { FiltersProps } from "@/components/pages/home/components/searchbar/components/filters-container";

const FilterButtons = ({
  filters,
  onSelectFilter,
  selectedFilter,
  displayCreateCustomVoice,
  scrollY,
}: FiltersProps) => {
  return (
    <div
      className={`${styles.items_wrapper} ${scrollY && scrollY > 30 ? styles.hidden : styles.visible}`}
    >
      {filters.map((item) => (
        <React.Fragment key={item.id}>
          {item.id === "special-filter" && displayCreateCustomVoice && (
            <CreateCustomVoiceFilterButton />
          )}
          <div
            className={`${styles.item} ${selectedFilter.id === item.id ? styles.active : ""}`}
            onClick={() => onSelectFilter(item)}
          >
            {item.title}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default FilterButtons;
